// extracted by mini-css-extract-plugin
export default {"empty-cart":"empty-cart--9WX9z","emptyCart":"empty-cart--9WX9z"};